import { NgModule } from "@angular/core";

import { FormsModule } from "@angular/forms";
import { SharedModule } from "@app2/shared/shared.module";
import { CommonModule } from "@angular/common";
import { TagsSectionComponent } from "@app2/tag/tags-section.component";
import { TagSearchMultiselectDropdownComponent } from "@app2/tag/filters/tag-search-multiselect-dropdown.component";
import { TagEditListComponent } from "@app2/tag/modals/tag-list.component";
import { TagAddListItemsModalComponent } from "@app2/tag/modals/tag-add-list-items-modal.component";
import { TagEditUniversalTagListModalComponent } from "@app2/tag/modals/tag-edit-universal-tag-list-modal.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
    ],
    declarations: [
        TagAddListItemsModalComponent,
        TagEditListComponent,
        TagsSectionComponent,
        TagEditUniversalTagListModalComponent,
        TagSearchMultiselectDropdownComponent,
    ],
    exports: [
        TagsSectionComponent,
        TagSearchMultiselectDropdownComponent,
    ],
})
export class TagSharedModule {
    constructor() {
    }
}
